export const pageContent = {
  paddingBottom: '75px',
};

export default pageContent;
